import styled, { keyframes, css } from 'styled-components'

export const spinning = keyframes`
  to {
    transform: rotate(360deg);
  }
`

interface StyledSpinnerProps {
  $transparent: boolean
  $localPosition: boolean
  $customStyles?: string
}

export const StyledSpinner = styled('div')<StyledSpinnerProps>(
  ({ $transparent, $localPosition, $customStyles }) => css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    ${!$transparent && 'background-color: rgba(0,0,0,.3)'};
    backdrop-filter: blur(5px);
    z-index: 100000;

    ${$localPosition &&
    css`
      position: absolute;
      background-color: transparent;

      /* -webkit-backdrop-filter: none;
      backdrop-filter: none; */
      padding: 8px;
      border-radius: inherit;
    `};

    ${$customStyles};
  `,
)

interface StyledSVGProps {
  $fill?: string
  $speed?: number
}

export const StyledSVG = styled.svg<StyledSVGProps>(
  ({ theme, $fill, $speed = 1.5 }) => css`
    animation: ${spinning} ${1.5 / $speed}s linear infinite;

    .icon-path {
      stroke: ${$fill || theme.colors?.primary};
    }
  `,
)

export const Message = styled.span`
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  white-space: break-spaces;
  margin-top: 32px;
`
